import {
    useRef
} from 'react';

import { SimpleGrid, Text } from '@mantine/core';
import { Link } from 'react-router-dom';

import { useProductLineItems } from '../hooks/useProductLineItems.ts';
import { useProductLineItemsSelection } from '../hooks/useProductLineItemsSelection.ts';

import {
    MantineDataTable,
    TableSearchForm,
} from '@flexinet/ui-components';
import { DataTableColumn } from "mantine-datatable";
import { DataTableTokenPagination } from "../../../components/DataTableTokenPagination.tsx";
import { ProductLineItem } from '../types';

interface RecordsTableProps {
    productId?: string;
}

export const RecordsTable = ({ productId }: RecordsTableProps) => {
    const {selectedRecords, setSelectedRecords} = useProductLineItemsSelection();

    const {
        items,
        totalCount,
        loading,
        nextToken,
        fetchRecords,
        handleFilterByKeyword
    } = useProductLineItems(productId || '');



    const scrollViewportRef = useRef<HTMLDivElement>(null);

    const columns: DataTableColumn<ProductLineItem>[] = [
        {
            accessor: 'productFeature.name',
            title: 'Feature',
            render: (record: ProductLineItem) => (
                <Link to={`/products/${productId}/product-line-items/${record.id}`} style={{ textDecoration: 'none' }}>
                    <Text c="blue" style={{ cursor: 'pointer' }}>
                        {record.productFeature?.name || 'Unknown Feature'}
                    </Text>
                </Link>
            )
        },
        { accessor: 'position', title: 'Position' },
        { accessor: 'created', title: 'Created' },
    ];

    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <TableSearchForm handleFilterByKeyword={handleFilterByKeyword} />

            <MantineDataTable
                columns={columns}
                records={items}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={setSelectedRecords}
                fetching={loading}
                onScrollToBottom={() => fetchRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
            />

            <DataTableTokenPagination totalCount={totalCount.toString()} nextToken={nextToken} handleLoadMore={fetchRecords} />

        </SimpleGrid>
    );
};